
function translate(key:string, lang:string) {
    const translations = require(`./languages/${lang}.json`);
    return translations[key] || key; // Retourne la traduction ou la clé si la traduction n'est pas disponible
  }

export default translate;